import styled from 'styled-components';
import D from '../../../../../../public/icon_triangle.svg'

interface BarProgressProps {
  color?: string;
}

interface DeltaProps{
  rotate:boolean
}

interface ContainerProp{
  isMobile?:boolean;
  indiciValue: string;
}

interface LayerProps{
  isMobile?:boolean;

}
export const Container = styled.div<ContainerProp>`
  height:  auto;
  opacity: 1;
  color: black;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  border: 1px solid var(--light-gray);
  background-color: white;
  flex-direction: column;
  position: fixed;
  bottom: ${props => props.indiciValue};
  left: ${props => props.isMobile ? '-6rem' : '-15rem'};
  scale: ${props => props.isMobile ? '123%': 'none'};

  h3{

    text-align: left;
    letter-spacing: 2px;
    color: #6C6C6C;
    opacity: 1;
    font-size: 10px;
    padding-bottom: 5px;
    font-weight: 600;
    display: flex;
    align-items: center;
  }
  `

export const Layer = styled.div<LayerProps>`
  width: 100%;
  height: 43px;
  background: #E7E7E7 0% 0% no-repeat padding-box;
  color: black;
  display: flex;
  justify-content: ${props => props.isMobile ? 'space-between':'flex-start'};
  align-items: center;
  p{
    padding-left: 15px;
    font-weight:900 ;
  }
  svg{
    margin-right: 15px;
        width: 32px;
  }

  @media (min-width: 820px) {
    svg{
      display: none;
    }
  }
`
export const RankingGeral = styled.div`
  width: 100%;
  height: auto;
  color: black;
  display: flex;
  flex-direction: column;
  border-bottom: 2px solid #BEBDBE;
  padding: 10px;
  padding-left: 15px;

  p{
    font-size: 12px;
    margin: 0;
  }
`
export const RankingArea = styled.div`
  width: 100%;
  height: auto;
  color: black;
  padding: 10px;
  display: flex;
  flex-direction: column;
  padding-left: 15px;

  .boxLabels{

    small{
      font-weight: 600;
      line-height: 13px ;
    }

    small:first-child{
      width: 116px;
    }

    display: flex;
    justify-content: space-around;
    width: auto;
  }

  @media (max-width: 820px) {
    .boxLabels{
      margin-bottom: 4%;
    }
  }
  small{
    font-size: 10px;
  }
  p{
    font-size: 12px;
    margin: 0;
  }
`

export const LayerArea = styled.div`

display: flex;
justify-content: flex-start;
.nome{
  min-width: 115px;
  width: auto;
  font-size: 10px  ;
  letter-spacing: 0px;

}
.indice{
  width: auto;
}
@media (max-width: 820px) {
  height: 20px;
}
`

export const Delta = styled(D)<DeltaProps>`
transform: rotate(${props => props.rotate ? '-180deg':'none'});
`

export const Label = styled.div`
  text-align: left;
  margin-bottom: 10px;
  letter-spacing: 2px;
  color: #6C6C6C;
  opacity: 1;
  font-size: 10px;
  display: flex;
  align-items: center;

`;
